import DataGridActionHeader from "../../../components/common/controls/grid/DataGridActionHeader";
import { useMemo } from "react";
import React from "react";
import ContactSalesGridFilter from "./ContactSalesGridFilter";

interface Props {
  onFilterChange: (selectedOption: any) => void;
}

const ContactSalesGridActionHeader = React.memo((props: Props) => {
  const { onFilterChange } = props;

  const FilterComponent = useMemo(() => () => {
      return <ContactSalesGridFilter onFilterChange={onFilterChange} />;
    },
    [onFilterChange]
  );

  return (
    <>
      <DataGridActionHeader
        displayNew={false}
        filterComponent={FilterComponent}
      />
    </>
  );
});

export default ContactSalesGridActionHeader;